<template>
	<div class="v-resume-end">
		<div class="v-resume-success">
			<div class="v-resume-title-wrap">
				<h2  class="v-resume-title v-resume-success__title v-resume-title--1">
					<img data-v-958f12be="" src="/static/images/elements/congrats.png">
					{{$tr('vacancy.openRegistrationVideoresume.end.title')}}
				</h2>
			</div>
			<v-resume-text :text="$tr('vacancy.openRegistrationVideoresume.end.ready')" />
			<div class="v-resume-success__link">
				<v-resume-link ref="link" :new-window="true" :large="true" :text="linkContent" :url="link" />
				<div class="v-resume-buttons">
					<div class="pointer" @click="copyLink">
						<icon-copy />
					</div>
					<a :href="'mailto:?body=' + link + ''" target="_blank" rel="noopener">
						<icon-mail class="pointer" />
					</a>
				</div>
			</div>
			<a class="v-resume-success__grey" href="https://www.vcv.me/howto" target="_blank" rel="noopener">{{$tr('vacancy.openRegistrationVideoresume.end.next')}}</a>
			<div class="v-resume-success__bottom">
				<v-resume-title :title="$tr('videoresume.rate')" size="4" />
				<v-resume-rating class="v-resume-rate-wrapper" name="rating" id="rating" @change="handleChange" />
				<div class="v-resume-rate-cont">
					<textarea
						class="v-resume-textarea"
						:placeholder="$tr('videoresume.content')"
						v-model="feedbackText"
						resizable="false"></textarea>
					<v-resume-button class="v-resume-success__button" text="Send" :disabled="submitButtonDisabled" @click="sendFeedback" style="float: right" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
const VResumeButton = () => import('@/components_new/b2c/vresume-button');
import VResumeLink from '@/components_new/b2c/vresume-link';
const VResumeShadowBox = () => import('@/components_new/b2c/vresume-shadow-box/index');
const VResumeText = () => import('@/components_new/b2c/vresume-text');
const VResumeTitle = () => import('@/components_new/b2c/vresume-title');
const VResumeRating = () => import('@/components_new/b2c/vresume-rating');
export default {
	components: {
		VResumeButton,
		VResumeLink,
		VResumeShadowBox,
		VResumeText,
		VResumeTitle,
		VResumeRating
	},
	props: ['link'],
	data() {
		return {
			feedbackText: null,
			feedbackRate: null
		}
	},
	computed: {
		submitButtonDisabled() {
			return !this.feedbackRate || !this.feedbackText
		},
		linkContent() {
			if (!this.link) {
				return '';
			}
			return this.link.replace(/^https?\:\/\//i, '');
		}
	},
	methods: {
		handleChange({ id, value }) {
			this.feedbackRate = value;
		},
		sendFeedback() {
			const model = {
				rate: this.feedbackRate ? +this.feedbackRate : null,
				text: this.feedbackText
			};
			this.$emit('submit', model)
		},
		copyLink () {
			const link = this.$refs.link.$refs.vresume_link;
			let rng = document.createRange();
			rng.setStart(link, 0);
			rng.setEnd(link, 1);
			let sel = window.getSelection();
			sel.removeAllRanges();
			sel.addRange(rng);
			try {
				document.execCommand('copy');
				window.getSelection().removeAllRanges();
				this.$noty.success(this.$tr('common.copy_link_success'));
			} catch (err) {
				console.log(err)
			}
		},
	}
}
</script>
<style lang="scss" scoped>
.v-resume-success {
	padding: 30px 0;
	text-align: center;
	// // font-family: 'Euclid Circular A';

	&__link {
		display: flex;
		align-items: center;
		justify-content: center;

		@media only screen and (max-width: 600px) {
			flex-direction: column;
		}

		::v-deep {
			.v-resume-link span {
				word-break: break-word;
				display: inline-block;
			}
		}
	}

	&__bottom {
		margin-top: 68px
	}

	::v-deep
	&__title {
		margin-bottom: 18px;
		margin-left: auto;
    	margin-right: auto;
	}
}

.v-resume-textarea {
	border: 1px solid #D1D8E0;
	border-radius: 4px;
	color: #8D8D8D;
	font-size: 15px;
	line-height: 24px;
	padding: 8px;
	display: block;
	width: 100%;
	resize: none;
	margin-bottom: 8px;
	min-height: 100px;

	&::placeholder {
		color: #C4B9D3;
	}
}

.v-resume-success__title {
	// // font-family: 'Euclid Circular A';
	font-style: normal;
	font-weight: bold;
	font-size: 30px;
	line-height: 36px;
	text-align: center;
	color: #555555;
}

.v-resume-buttons {
	margin-left: 16px;
	display: flex;
    align-items: center;
	& > * {
		display: flex;
    	align-items: center;
		&:not(:last-child) {
			margin-right: 8px;
		}
	}

	a {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		height: 16px;
	}

	svg {
		height: 16px;
	}
}

.pointer {
	cursor: pointer;
}

.v-resume-title-wrap {
	display: flex;
	align-items: center;

	img {
		position: relative;
		top: 5px;
		margin-right: 4px;
	}
}

.v-resume-success__grey {
	display: block;
	margin-top: 18px;
	text-align: center;
	// // font-family: 'Euclid Circular A';
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
	color: #C4B9D3;

	&:hover,
	&:focus,
	&:active {
		color: #C4B9D3;
	}
}

.v-resume-rate-wrapper {
	margin-top: 8px;
	margin-bottom: 8px;
}

.v-resume-rate-cont {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}
</style>
